"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgOdnoklassniki = function SvgOdnoklassniki(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.186C0 8.644 0 4.872 2.343 2.529S8.458.186 16 .186c7.543 0 11.314 0 13.657 2.343S32 8.644 32 16.186c0 7.543 0 11.314-2.343 13.657S23.543 32.186 16 32.186c-7.542 0-11.314 0-13.657-2.343S0 23.729 0 16.186Z",
    fill: "url(#Odnoklassniki_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.592c-2.67 0-4.844 2.178-4.844 4.856S13.33 16.304 16 16.304c2.672 0 4.844-2.178 4.844-4.856S18.672 6.592 16 6.592Zm0 2.845a2.01 2.01 0 0 1 0 4.021 2.01 2.01 0 0 1 0-4.02Zm-3.993 7.032a1.426 1.426 0 0 0-.78 2.628 9.075 9.075 0 0 0 2.812 1.168l-2.707 2.715a1.426 1.426 0 0 0 0 2.012 1.415 1.415 0 0 0 2.008 0L16 22.324l2.661 2.668a1.416 1.416 0 0 0 2.007 0 1.425 1.425 0 0 0 0-2.012l-2.709-2.715a9.062 9.062 0 0 0 2.813-1.168 1.425 1.425 0 0 0 .446-1.962 1.417 1.417 0 0 0-1.958-.447 6.137 6.137 0 0 1-6.521 0 1.41 1.41 0 0 0-.732-.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Odnoklassniki_svg__a",
    x1: 16,
    y1: 0.186,
    x2: 16,
    y2: 32.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF831D"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgOdnoklassniki);
var _default = exports["default"] = Memo;